<div class="is-active-cell-renderer" [class.active]="isActive === true">
  <fa-icon
    [icon]="isActive === true ? ['fas', 'check'] : ['fas', 'xmark']"
  ></fa-icon>
</div>
